import { selectOrganizationSelected } from "@app/organizations";
import { useSelector } from "@app/react";

import { AppSidebarLayout } from "../layouts";
import { ActivityByOrgV2, Loading } from "../shared";

export const ActivityPage = () => {
  const org = useSelector(selectOrganizationSelected);
  if (!org.id) {
    return <Loading text="Loading activity" />;
  }

  return (
    <AppSidebarLayout mainWrapperDivClassName="overflow-x-hidden">
      <ActivityByOrgV2 orgId={org.id} />
    </AppSidebarLayout>
  );
};
